import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'CampAthletes';

const CampAthletesApi: any = baseApi(endpoint);

export default CampAthletesApi;